<header class="header">
  <lfwms-menu></lfwms-menu>
  <lfwms-profile></lfwms-profile>
</header>